import { unitInstanceFromStep } from '@cards/engine';
import { cardRef, defineGameCard, onResolve, planningTargets, targetStep, unitTarget, } from '../authoring/index.js';
export const BandageWoundsCard = defineGameCard({
    id: 'bandage_wounds',
    gameplay: {
        type: 'SPELL',
        cost: 2,
        planning: planningTargets([
            targetStep('target', unitTarget({
                side: 'ally', cardTypes: ['UNIT'], cardinality: { min: 1, max: 1 },
            })),
        ]),
    },
    presentation: {
        name: 'Перевязка ран',
        description: 'Выбранный союзный боец восстанавливает 3 здоровья. Если он был полностью здоров, вместо этого получает Щит 1.',
        glyph: {
            colors: ['#10213A', '#EFEEEE', '#CFCDCD', '#C0BAB7', '#E21B28'],
            rows: [
                '...11111111111111...',
                '..12223333222232211.',
                '.1333332222222333341',
                '13332222333333223341',
                '12322333444422322321',
                '12232222222222223321',
                '14322333333333322341',
                '14322222222222222241',
                '14222222555522222241',
                '14222222555522222231',
                '14222222555522222231',
                '14222255555555222231',
                '14222255555555222231',
                '14222255555555222231',
                '14222222555522222241',
                '14322222555522222341',
                '14322222555522223341',
                '.143322222222223341.',
                '..1333333333444441..',
                '...11111111111111...',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('bandage_wounds')],
    abilities: [onResolve((ctx) => {
            const targetId = unitInstanceFromStep(ctx.plan?.selections ?? [], 'target');
            const target = targetId === undefined ? null : ctx.q.instance(targetId);
            if (ctx.self === undefined || target?.zone !== 'board'
                || target.controllerId !== ctx.self.controllerId || ctx.q.cardType(target.id) !== 'UNIT')
                return;
            const stats = ctx.q.stats(target);
            if (stats.health >= stats.maxHealth) {
                ctx.ops.addShield(BandageWoundsCard.id, target.id, 1, ctx.self.id);
            }
            else {
                ctx.ops.restoreUnitHealth(target.id, 3, ctx.self.id);
            }
        })],
    ui: {
        mechanics: ['shield'],
        planning: { steps: { target: { label: 'Выберите союзного бойца' } } },
    },
});
//# sourceMappingURL=bandage_wounds.js.map